<template>
<div>   

    <el-col   :span="23"    class="affix_wrap"  >
        <div class="affix_box"  v-for="(item) of affixfileList"   :key="item.id">
            <div class="up">  
                
                <img v-if='item.fileName.search(/\.pdf/i)!=-1' src="@/assets/images/PDF.png" alt="" @click="OpenFile(item.tempLink)"> 
                <img v-else-if='item.fileName.search(/\.doc/i)!=-1  ' src="@/assets/images/word.png" alt="" @click="OpenFile(item.tempLink)"> 
                <img v-else-if='item.fileName.search(/\.xls/i)!=-1 || item.fileName.indexOf(".csv")!=-1' src="@/assets/images/excel.png" alt="" @click="OpenFile(item.tempLink)"> 
                <img v-else-if='item.fileName.search(/\.ppt/i)!=-1  ' src="@/assets/images/ppt.png" alt="" @click="OpenFile(item.tempLink)">  

                <img v-else-if="isImg(item.fileName)" :src="item.tempLink" :alt="item.fileName" @click="CheckFile(item)">
                <img v-else  src="@/assets/images/unknowfile.png" :alt="item.fileName"  @click="OpenFile(item.tempLink)">


            </div>
            <div class="down">{{item.fileName}}  </div>

            
        </div>

            
    </el-col>


    <el-dialog :visible.sync="dialogVisible"  custom-class="detail_dia"    top='5vh' >
        <img   style="max-width:100%;height:auto" :src="dialogImageUrl" alt=""  >
    </el-dialog>
</div>
    
	 
	
</template>

<script>
 

	export default {
    name: 'affix_box',
    props: {
            // detail_visible:Boolean,
            // current_form:Object,
            affixfileList:Array,
        },
        components: { 
 
 
            
         
        },
        data() {
			return { 
            //    detail_visible:true ,
                // detail_visible:false,
                screenHeight:window.innerHeight || '',
                dialogVisible:false,
                dialogImageUrl:''
           
			}
        },
        mounted(){
     
           
        },
        methods: {
            CheckFile(item){

                console.log('check file item:',item)
               
                this.dialogImageUrl = item.tempLink ;
                this.dialogVisible = true;

                // window.open(item.tempLink)


            },

            OpenFile(tempLink){
                console.log('OpenFile--------')
                window.open(tempLink, "_blank")

            },
            isImg(filename){
                //  return [
                //     '.png', '.jpg', '.jpeg', '.bmp', '.gif', '.webp', '.psd', '.svg', '.tiff'].
                //     indexOf(ext.toLowerCase()) !== -1;


                return (/\.(gif|jpe?g|tiff?|png|webp|bmp)$/i).test(filename);


            }


        }
	}
</script>

<style >
 .detail_dia{
    overflow-y: scroll;
    max-height: 90vh;
    border-radius: 5px;
 }

</style>
